import React from 'react'
import { BsFileEarmarkPdfFill, BsFileEarmarkPptFill, BsFileEarmarkWordFill, BsFileEarmarkImageFill } from 'react-icons/bs';
const FileFormat = ({ mimeType }) => {
    if (mimeType) {
        return (
            <img className='iconformat' src={`https://drive-thirdparty.googleusercontent.com/32/type/${mimeType}`} />
        )
    }
    // else if(mimeType==="ppt") {
    //     return(
    //         <BsFileEarmarkPptFill className='iconformat'/>
    //     )
    // }

    // else if(mimeType==="word") {
    //     return(
    //         <BsFileEarmarkWordFill className='iconformat'/>
    //     )
    // }
    else {
        return (
            <BsFileEarmarkImageFill className='iconformat' />
        )
    }
}

export default FileFormat
